import home from './home';
import tutoring from './tutoring';

export default { home, tutoring };
